module.exports = __webpack_public_path__ + "static/media/mendo.1f1b0b2d.png";